import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apiUrl } from './utils/api';

export default function CompanyActivation() {
  const [token] = useState(() => {
    const value = new URLSearchParams(window.location.hash.slice(1)).get('token') || '';
    return value;
  });
  useEffect(() => { window.history.replaceState(null, '', window.location.pathname); }, []);
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  async function submit(event) {
    event.preventDefault();
    if (password !== confirmation) return setError('The passwords do not match.');
    setBusy(true); setError('');
    try {
      const response = await fetch(apiUrl('/api/company-activation'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token, password }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.error || 'Account setup failed.');
      setPassword(''); setConfirmation(''); setDone(true);
    } catch (failure) { setError(failure.message); }
    finally { setBusy(false); }
  }
  return <main className="min-h-screen flex items-center justify-center bg-blue-50 p-4"><section className="max-w-md w-full rounded-lg bg-white p-8 shadow-lg">
    <h1 className="text-2xl font-bold mb-4">Set up your company account</h1>
    {done ? <p>Your password is set. <Link className="text-blue-700 underline" to="/login">Sign in to your company</Link></p> : <form onSubmit={submit}>
      {!token && <p role="alert">Open your private account setup link to continue.</p>}
      <label className="block mb-4">New password<input className="block w-full border rounded p-3" type="password" autoComplete="new-password" minLength={12} required value={password} onChange={e => setPassword(e.target.value)} /></label>
      <label className="block mb-4">Confirm password<input className="block w-full border rounded p-3" type="password" autoComplete="new-password" required value={confirmation} onChange={e => setConfirmation(e.target.value)} /></label>
      <p className="text-sm mb-4">Use at least 12 characters.</p>
      {error && <p role="alert" className="text-red-700 mb-4">{error}</p>}
      <button className="bg-blue-700 text-white rounded px-4 py-3 disabled:opacity-50" disabled={busy || !token}>{busy ? 'Saving…' : 'Set password'}</button>
    </form>}
  </section></main>;
}
